import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { tap, catchError } from 'rxjs/operators';
import { config } from '../config';
import { Residence } from '../model/residence';
import { ErrorHandlerService } from './errorHandler.service';
import { off } from 'process';

import { Router } from '@angular/router';
import { timeout } from 'rxjs/operators';
import { Wait } from '../util/timeout';

@Injectable({
  providedIn: 'root',
})
export class ResidencesService {

  constructor(private http: HttpClient, private handleError: ErrorHandlerService, private router: Router) { }

  getAll(): Observable<any> {
    return this.http.get<any>(`${config.apiUrl}/Residences`)
      .pipe(timeout(Wait),
        tap(resp => {
          return resp;
        }),
        catchError(error => {
          console.error('Error in ResidencesService.getAll:', error);
          if (error.message == 'Timeout has occurred') {
            this.handleError.toastTimeout('Demora na comunicação com servidor');
          }
          return of({ items: [], TotalItems: 0 });
        }));
  }

  getDestinations(): Observable<any> {
    return this.http.get<any>(`${config.apiUrl}/Residences/destinations`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of([]);
        }));
  }

  add(residence: Residence): Observable<any> {
    return this.http.post<any>(`${config.apiUrl}/Residences`, residence)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          this.handleError.popupError(error, 'Falha na comunicação com o servidor...', 'Não foi possível cadastrar nova residência');
          return of(false);
        }));
  }

  update(residence: Residence): Observable<any> {
    return this.http.put<any>(`${config.apiUrl}/Residences/${residence.id}`, residence)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          this.handleError.popupError(error, 'Falha na comunicação com o servidor...', 'Não foi possível atualizar as informações de residência');
          return of(false);
        }));
  }

  delete(residenceId: number): Observable<any> {
    return this.http.delete<any>(`${config.apiUrl}/Residences/${residenceId}`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          this.handleError.popupError(error, 'Falha na comunicação com o servidor...', 'Não foi possível remover o registro de residência');
          return of(false);
        }));
  }

  getById(residenceId: number) {
    return this.http.get<any>(`${config.apiUrl}/Residences/${residenceId}`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of(false);
        }))

  }
}
